import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { TextEditorFactory } from '../../factories/TextEditorFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class TextEditor extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new TextEditorFactory
  }

  info() {
    return {
      name: 'TextEditor',
      icon: 'fa-font',
      variations: this.variationsInfo()
    }
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes']
  }

  elementContents() {
    return ['text']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
    ]
  }
}